<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateProductoPaginaIdroop"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductPagesOfGratefulnessModalEditExternalSite.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        key="modal section"
        class="m-the-modal-section-height-auto"
      >
        <AtomInputPrimary
          v-model="pagina.nombre"
          :inputError="$v.pagina.nombre.$error"
          :label="$t('mEditionProductPagesOfGratefulnessModalEditExternalSite.inputs.nombre.label')"
          :message="$t('mEditionProductPagesOfGratefulnessModalEditExternalSite.inputs.nombre.message')"
          :messageError="messageErrorNombre"
          name="nombre"
          :placeholder="$t('mEditionProductPagesOfGratefulnessModalEditExternalSite.inputs.nombre.placeholder')"
          type="text"
          @blur="$v.pagina.nombre.$touch()"
        />
        <AtomInputPrimary
          v-model="pagina.url"
          :inputError="$v.pagina.url.$error"
          :label="$t('mEditionProductPagesOfGratefulnessModalEditExternalSite.inputs.url.label')"
          :messageError="messageErrorUrl"
          name="url"
          :placeholder="$t('mEditionProductPagesOfGratefulnessModalEditExternalSite.inputs.url.placeholder')"
          type="text"
          @blur="$v.pagina.url.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductPagesOfGratefulnessModalEditExternalSite.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required, url } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionProductPagesOfGratefulnessModalEditExternalSite',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductPagesOfGratefulnessModalEditExternalSite.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      pagina: {
        nombre: this.$modal.element.pagina.nombre,
        url: this.$modal.element.pagina.url
      }
    }
  },

  validations: {
    pagina: {
      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      },

      url: {
        required,
        url
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionProductPagesOfGratefulnessModalEditExternalSite', this.$v.pagina.nombre, 'nombre')
    },

    messageErrorUrl () {
      return this.$validation.getValidationMessage('mEditionProductPagesOfGratefulnessModalEditExternalSite', this.$v.pagina.url, 'url')
    }
  },

  methods: {
    updateProductoPaginaIdroop () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('producto', 'updateProductoPaginaIdroop', this.pagina, [this.$modal.element.pagina.id])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductPagesOfGratefulnessModalEditExternalSite', 'updateProductoPaginaIdroop', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductPagesOfGratefulnessModalEditExternalSite', 'updateProductoPaginaIdroop', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
